export const licenceExpired = state => state.licenceExpired
export const showSpinnerRequestCount = state => state.showSpinnerRequestCount
export const spinnerMessage = state => state.spinnerMessage
export const debounceDelay = state => state.debounceDelay
